module.exports = __webpack_public_path__ + "static/media/light-bulb.cdf5f2bf.svg";